// extracted by mini-css-extract-plugin
export default {"listCard":"HistoryList_listCard__wgKiZ","listContainer":"HistoryList_listContainer__NNHcT","result":"HistoryList_result__Hh4JC"};